
import React from 'react';
import { useTShirtStats } from '@/hooks/admin/useTShirtStats';
import { Attendee } from '@/types/attendee';
import TShirtSizeSummary from './TShirtSizeSummary';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shirt } from 'lucide-react';
import { motion } from 'framer-motion';

interface AdminTShirtStatsProps {
  attendees: Attendee[];
  className?: string;
}

const AdminTShirtStats: React.FC<AdminTShirtStatsProps> = ({ attendees, className }) => {
  // Use our dedicated hook for T-shirt stats
  const stats = useTShirtStats(attendees);
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={{ y: -2 }}
      className="transition-shadow hover:shadow-md"
    >
      <Card className={`${className || ''} w-full border-blue-200 bg-white dark:bg-slate-900 shadow overflow-hidden`}>
        <CardHeader className="pb-2 bg-gradient-to-r from-blue-50 to-sky-50 dark:from-blue-950/30 dark:to-sky-950/30 border-b border-blue-100 dark:border-blue-800/30">
          <CardTitle className="text-sm flex items-center gap-2 text-blue-800 dark:text-blue-300">
            <Shirt className="h-4 w-4 text-blue-600 dark:text-blue-400" />
            <span>Thống kê chi tiết áo Kỷ Niệm</span>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3">
          <TShirtSizeSummary stats={stats} className="border-none shadow-none bg-transparent" />
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default AdminTShirtStats;
